import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectHero from '../../components/hero3/projecthero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ClientNumber from '../../components/business-consulting-components/clientnumber';
import srj1 from '../../images/elise1.png'
import srj2 from '../../images/srj2.svg'
import srj3 from '../../images/elise3.png'
import srj4 from '../../images/srj4.png'
import srj5 from '../../images/srj5.png'
import srj6 from '../../images/srj6.png'
import srj7 from '../../images/elise7.png'
import srj8 from '../../images/srj8.png'
import srj9 from '../../images/srj9.png'
import srj10 from '../../images/elise10.png'
import CaseStudiesSlider from '../../components/business-consulting-components/CaseStudiesSlider';



const Elise = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting'>
                <main className="page_content s2">
                    <Header3 />
                    <ProjectHero top_title={<>B2B Pharma SEO <br/> Turnaround for a Private- <br/> Label Manufacturer</>}/>

                    <section className="video_section">
                        <div className="container text-center project_page_desp">
                            <h2>Company Overview</h2>

                            <ul className='project_page_ul'>
                                <li>
                                    <span className='number_css'>150+</span>
                                    <span className='hero_bottom_text'>Team Size</span>
                                </li>
                                <li>
                                    <span className='number_css'>Canada</span>
                                    <span className='hero_bottom_text'>Country</span>
                                </li>
                                <li>
                                    <span className='number_css'>B2B</span>
                                    <span className='hero_bottom_text'>Industry</span>
                                </li>
                                <li>
                                    <span className='number_css'>White Label Pharma Company</span>
                                    <span className='hero_bottom_text'>Category</span>
                                </li>
                            </ul> 
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>About Business</h2>
                                    <p className='heading_description text-dark mb-0'>Elise, the CMO of a large B2B pharmaceutical and <br/> nutraceutical manufacturer in Canada, supplies <br/> private-label products for multiple brands and <br/> exports to 49+ countries.</p>
                                </div>

                                <div className="col-lg-6" style={{textAlign:'right'}}>
                                    <img src={srj1} alt="srj1" style={{maxWidth:'60%'}}/>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={srj2} alt="aiseo" className='img-fluid' style={{maxWidth:'60%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Client Challenges</h2>
                                    <p className='heading_description text-dark mb-0'>Before engaging Digi Pexel, the client was facing a steady decline in their digital presence despite working with multiple consultants and agencies. Their marketing team struggled to pinpoint the root causes behind the performance drop, and the impact was clearly visible on lead flow and sales conversations.</p>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Continuous decline in organic traffic over three quarters</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Falling SERP rankings despite previous SEO efforts</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Significant drop in inbound leads from organic channels</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>A growing share of low-value and spam inquiries is impacting lead quality</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0 max_900">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Overview</h2>
                                    <h3 className='mt-4'>SEO Brief</h3>
                                    <p className='heading_description text-dark mb-0'>During onboarding, Elsi shared that marketing had relied heavily on a rotating mix of consultants and agencies. Despite multiple engagements, the core issues persisted, and she now wanted a reliable, long-term SEO partner that genuinely understands pharma and nutraceuticals.</p>
                                
                                     <h3 className='mt-4'>Client Ask</h3>

                                      <p className='heading_description text-dark mb-0'>Elsi wants to focus on the long-term solution, not just fixing up for the short-term results. She wants us to focus on the following things.</p>
                                      <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Diagnose root causes behind a continuous 6-month drop in rankings and traffic.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Improve the quality of lead flow, not just the volume.</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Deliver a detailed plan to scale SEO and marketing sustainably.</li>
                                    </ul>
                                    <p className='heading_description text-dark mb-0'>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its </p>

                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <img src={srj3} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj7} alt="srj3" className='img-fluid' />
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container">
                            <div className="row challenges_css">
                                <div className="col-lg-6">
                                    <img src={srj8} alt="aiseo" className='img-fluid' style={{maxWidth:'70%',marginTop:'20%'}}/>
                                </div>

                                <div className="col-lg-6">
                                    <h2>Challenges We Faced</h2>
                                    <ul class="srj_list mt-4 ">
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Fragmented historical analytics and unclear MQL/SQL definitions across teams</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Thin and overlapping pages targeting similar intents (cannibalization)</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>YMYL sensitivity: content needs medical, regulatory, and QA oversight</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>International complexity (Canada-first with U.S. and priority export markets)</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Legacy CMS constraints affecting Core Web Vitals and templating</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Weak author reputation signals (no medically qualified reviewers visible)</li>
                                        <li><i class="fa fa-check check_icon" aria-hidden="true"></i>Unstructured lead forms leading to spam and low-intent submissions</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="intro_about_section section_space solution pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <h2>Solution Provided</h2>
                                </div>

                                <div className="col-lg-6">
                                    <ul class="srj_list solution_list mt-4">
                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Diagnosis & Audit</div>
                                                <p><b>90-point Technical Audit:</b> crawl depth, render blocking JS, canonical/parameter clean-up, sitemap & robots, pagination, and duplicate templates.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Content Strategy (Topical Authority)</div>
                                                <p>Pillar–cluster map for B2B pharma/nutra segment, which helped us in topical authority and ranking.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>AI SEO Optimization</div>
                                                <p><b>Answer Engine Optimization (AEO/GEO):</b> structured Q&A blocks, concise definitions, glossary pages, and FAQ schema to perform in AI overviews and answer engines.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>On-Page Strategy</div>
                                                <p>Entity-rich copy optimized for search intent (buyer vs research), with modular CTAs by intent stage.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Schema Enhancements</div>
                                                <p><b>Comprehensive Schema Set:</b> Organization, Product/Service, FAQ, Breadcrumb, and Review (where policy-compliant). And an Internal linking graph that routes discovery-stage traffic → capability pages → RFQ paths.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>CRO & Lead Quality Uplift</div>
                                                <p>Redesigned RFQ forms with qualification gates (MOQ ranges, target markets, regulatory requirements) and progressive profiling. And created high-intent assets (RFP templates, compliance checklists) gated behind minimal friction, improving signal in form fills.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>PR & Backlinks Strategy</div>
                                                <p>Executive POV content on regulatory trends (Health Canada/FDA considerations), supply chain resilience, and innovation in delivery systems. Targeted link reclamation, unlinked brand mentions, and byline contributions from qualified experts.</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Analytics, Governance & Ops</div>
                                                <ul>
                                                    <li>GA4 + GSC + CRM multi-touch dashboards; pipeline attribution (first-touch SEO vs assisted conversions). </li>
                                                    <li>Quarterly roadmap: tech debt burndown, content expansion, and market-specific landing rollouts.</li>
                                                </ul>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </section>

                    <ToolSection title1={<>Partner with us and get your custom AI SEO <br/> strategy for your business</>} title2='' />
                    
                    <section className="intro_about_section section_space project_outcome max_900 pt-0">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <h2>Project Outcome (6 Months)</h2>
                                </div>

                                <div className="col-lg-10 offset-lg-2">
                                    <ul class="srj_list solution_list mt-4">

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Non-brand Organic Sessions</div>
                                                <p><b>+88%</b> non-brand organic sessions (stabilization within 60 days; sustained growth thereafter)</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Google SERP Result</div>
                                                <p>+120 net new Top-3 keyword positions across capability and compliance clusters</p>
                                            </div>
                                        </li>

                                         <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Conversion Rate</div>
                                                <p>2.4× improvement in MQL → SQL conversion rate (better form design + scoring)</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Better Quality Leads</div>
                                                <p>−41% reduction in spam/low-intent submissions</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Quotation Request</div>
                                                <p>3.1× increase in enterprise RFQs from North America priority segments</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Lead Flow</div>
                                                <p>+28% increase in pipeline influenced by SEO (multi-touch)</p>
                                            </div>
                                        </li>

                                        <li className='moveUpOnlyNew'>
                                            <div className='solution_item'>
                                                <div><img src={srj9}/>Improved Technical SEO</div>
                                                <p>Core Web Vitals: INP moved from “needs improvement” to “good” on high-traffic templates</p>
                                            </div>
                                        </li>



                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </section>
                    <ClientNumber/>

                    <section className="intro_about_section section_space project_outcome">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <img src={srj10} alt="srj10" className='img-fluid' />
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <section className="intro_about_section section_space pt-0">
                        <div className="container max_900">
                            <div className="row">
                                <div className="col-lg-12 text-center tool_section_new">
                                    <h2>Partner with us and get your custom AI SEO <br/> strategy for your business</h2>
                                    <button className="read_more btn btn-secondary">Contact Now</button>
                                </div>
                            </div>                            
                        </div>
                    </section>

                    <CaseStudiesSlider/>
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default Elise;
